import { isMobile } from '@growtherapy/analytics';

import { isSafari as isBrowserSafari } from '../../utils';
import { BlockedPermissionsActionItem, BlockedPermissionsActionItemProps } from './BlockedPermissionsActionItem';

export function BlockedPermissionsActionItemWrapper({
  isDarkTheme,
}: Pick<BlockedPermissionsActionItemProps, 'isDarkTheme'>) {
  const isMobileDevice = isMobile(navigator.userAgent);
  const isSafari = isBrowserSafari();
  return <BlockedPermissionsActionItem isMobile={isMobileDevice} isSafari={isSafari} isDarkTheme={isDarkTheme} />;
}
